import { render, staticRenderFns } from "./AS_FooterMobile.vue?vue&type=template&id=7c5bd722&scoped=true&"
var script = {}
import style0 from "./AS_FooterMobile.vue?vue&type=style&index=0&id=7c5bd722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5bd722",
  null
  
)

export default component.exports